// extracted by mini-css-extract-plugin
export default {"ServiceDetail":"styles_ServiceDetail__OSJpg","ServiceDetail__container":"styles_ServiceDetail__container__-Wd1u","ServiceDetail__button":"styles_ServiceDetail__button__T0vaY"};